import { Routes } from "@angular/router";
import { ReleaseCalendarPageComponent } from "./release-calendar-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const releaseCalendarPageRoutes: Routes = [
  {
    path: 'records/release-calendar',
    component: ReleaseCalendarPageComponent,
    canActivate: [authGuard]
  }
]
